import {useEffect ,useState,React }from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string';
import PlanEditor from './EditorPages/PlanEditor';
import PlanResults from './ResultsPages/PlanResults';

function Plans({
    urlParams
}) {
    const [queryParams,setQueryParams] = useState(urlParams);
    useEffect(() => {
        setQueryParams(queryString.parse(urlParams));
    },[urlParams])
    return (
        queryParams && queryParams['id'] ?
            <PlanEditor id={queryParams['id']} /> :
            <PlanResults />
    );
}

const mapStateToProps = (state) => ({
    urlParams: state.router.location.search,
});

export default connect(mapStateToProps, null)(Plans);